export const gradientColor = {
	light: "#9EF0E1",
	dark: "#439288",
};
